// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('SafraCtrl', function(
  $location, $scope, $rootScope, $routeParams,
  SafrasService, Flash, LoadingService, MessagesService, CommonHTTPService
) {
  $scope.safra = {};
  $scope.data_inicial_invalida = false;

  // eslint-disable-next-line max-lines-per-function
  const initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if ($scope.$root.parametros.nao_cliente_agrogestao && $rootScope.permissions.safras.canManage) {
        if ($routeParams.id) {
          SafrasService.get($routeParams.id).then(function(result) {
            $scope.safra = result.data;
            $scope.safra.data_inicial = moment($scope.safra.data_inicial).startOf('day')
              .toDate();
            $scope.safra.data_final = moment($scope.safra.data_final).startOf('day')
              .toDate();
          })
            .catch($rootScope.errorRootInitialize)
            .finally(LoadingService.hideLoading);
        }
      } else {
        $location.path('/');
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        // eslint-disable-next-line no-useless-return
        return;
      }
      LoadingService.hideLoading();
    });
  };

  initialize();

  $scope.goToIndex = function() {
    $location.path('/safras');
  };

  $scope.save = function(form) {
    if (form.$invalid) {
      return;
    }

    if ($scope.safra.data_inicial > $scope.safra.data_final) {
      $scope.data_inicial_invalida = true;
    } else {
      LoadingService.showLoading();
      SafrasService.save($scope.safra)
        .then(function() {
          $scope.goToIndex();
          Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
        })
        .catch(function(e) {
          if (CommonHTTPService.isBadRequest(e.status) && e.data.descricao) {
            MessagesService.alert('Descrição já está em uso!');
          } else if (CommonHTTPService.isBadRequest(e.status) && e.data.data_inicial) {
            const msg = e.data.data_inicial[0];
            MessagesService.alert(msg);
          } else {
            MessagesService.alert(FALHA_AO_SALVAR_REGISTRO.msg);
          }
        })
        .finally(LoadingService.hideLoading);
    }
  };
});
